<template>
  <Agendamento></Agendamento>
</template>

<script>
import Agendamento from "../components/Agendamento";
export default {
  components: {Agendamento}
};
</script>

